import { useEffect } from "react";

/**
 * Layout に「未保存変更があるか」を通知する Hook
 */
export const useDirtyState = (dirty) => {
  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("app:setDirty", {
        detail: { dirty: !!dirty },
      })
    );

    return () => {
      // ページ離脱時は必ずクリア
      window.dispatchEvent(
        new CustomEvent("app:setDirty", {
          detail: { dirty: false },
        })
      );
    };
  }, [dirty]);
};
